import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Typography } from '@mui/material';
import tickmark from 'assets/images/tickmark.svg'

export default function SuccessDialog(props) {

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container>
              <Grid item xs={12} className='formPadding justifyAlignCenter marginMarkStyle'>
                <Grid className='tickMarkStyle'>
                  <img src={tickmark} alt="success" />
                </Grid>
              </Grid>
              <Grid item xs={12} className="dialogHead">

                <Typography className='titleStyle'>
                  {props.type === "Edit Type" ? props.type : null}
                  <span className='colorSecondary'>{props.type === "Edit Type" ? "Registered" : props.type === "Updated" ? "Mobile Number Changed" : " Approved"}</span>
                </Typography>

              </Grid>
              <Grid item  >
                <p className='justifyAlignCenter padding20'>{props.type !== "Edit Type" ? props.data : null}</p>
              </Grid>

            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}